import { alpha, styled } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const ODD_OPACITY = 0.2;

export const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`&.${gridClasses.root}`]: {
        borderLeft: "1px",
        borderRight: "1px",
        borderBottom: "1px",
        borderTop: "1px",
        borderTopLeftRadius: "14px",
        borderTopRightRadius: "14px",
    },
    [`& .${gridClasses.cell}`]: {
        whiteSpace: "nowrap !important",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
    },
    [`& .${gridClasses.cell}:focus`]: {
        outline: "none",
    },
    "& ::-webkit-scrollbar": {
        width: "5px",
    },
    "& ::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[300],
    },
    "& ::-webkit-scrollbar-thumb": {
        borderRadius: "20px",
        backgroundColor: theme.palette.main2.main,
    },
    [`& .${gridClasses.columnHeader}`]: {
        backgroundColor: theme.palette.main3.main,
        color: theme.palette.main3.contrastText,
    },
    [`& .${gridClasses.columnHeaderTitle}`]: {
        whiteSpace: "normal",
        lineHeight: "normal",
        textAlign: "center",
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
        fontFamily: theme.typography.fontFamily,
    },
    [`& .${gridClasses.menuIconButton}`]: {
        color: theme.palette.main3.contrastText,
    },

    [`& .${gridClasses.filterIcon}`]: {
        color: theme.palette.main3.contrastText,
    },
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.mainBase30.main,
        "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            "@media (hover: none)": {
                backgroundColor: "transparent",
            },
        },
        "&.Mui-selected": {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY + theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));
